module.exports = __webpack_public_path__ + "img/Shower&Diaper Change.f310c753.png";